'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _templateObject = _taggedTemplateLiteral(['\n      background-image: url(', ');\n\n      @media (min-width: ', ') {\n        background-image: url(', ');\n      }\n    '], ['\n      background-image: url(', ');\n\n      @media (min-width: ', ') {\n        background-image: url(', ');\n      }\n    ']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactEmotion = require('react-emotion');
var _jsCookie = require('js-cookie');
var Cookies = _interopRequireWildcard(_jsCookie);
var _reactTransitionGroup = require('react-transition-group');
var _variables = require('../utility/variables');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Agegate = function (_React$Component) {
  _inherits(Agegate, _React$Component);
  function Agegate() {
    _classCallCheck(this, Agegate);
    var _this = _possibleConstructorReturn(this, (Agegate.__proto__ || Object.getPrototypeOf(Agegate)).call(this));
    _this.state = {
      isShown: false,
      isTwentyOne: false,
      yearValue: '',
      monthValue: '',
      dayValue: '',
      errorUnderAge: false,
      errorInvalid: false
    };
    _this.handleCookieCheck = _this.handleCookieCheck.bind(_this);
    _this.handleYearChange = _this.handleYearChange.bind(_this);
    _this.handleMonthChange = _this.handleMonthChange.bind(_this);
    _this.handleDayChange = _this.handleDayChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }
  _createClass(Agegate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleCookieCheck();
      this.bgImage = (0, _reactEmotion.css)(_templateObject, this.props.bgMobile, _variables.mediaQueries.sm, this.props.bgDesktop);
    }
  }, {
    key: 'handleCookieCheck',
    value: function handleCookieCheck() {
      this.props.onCookieCheck(this);
    }
  }, {
    key: 'handleYearChange',
    value: function handleYearChange(e) {
      this.props.onYearChange(e, this);
    }
  }, {
    key: 'handleMonthChange',
    value: function handleMonthChange(e) {
      this.props.onMonthChange(e, this);
    }
  }, {
    key: 'handleDayChange',
    value: function handleDayChange(e) {
      this.props.onDayChange(e, this);
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      this.props.onSubmit(e, this);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_reactTransitionGroup.CSSTransitionGroup, {
        transitionName: 'agegate',
        transitionEnter: false,
        transitionLeaveTimeout: this.props.leaveTimeout
      }, this.state.isShown ? _react2.default.createElement('div', {
        className: 'agegate ' + this.props.className + ' ' + this.bgImage
      }, _react2.default.createElement('div', {
        className: 'agegate__inner'
      }, this.props.headlineImage ? _react2.default.createElement('img', {
        className: 'agegate__headline-img',
        src: this.props.headlineImage,
        alt: this.props.headlineImageAlt
      }) : null, _react2.default.createElement('h1', {
        className: 'agegate__headline'
      }, this.props.headline), _react2.default.createElement('h2', {
        className: 'agegate__copy'
      }, this.props.copy), this.state.errorUnderAge ? _react2.default.createElement('span', {
        className: 'error error--under-age'
      }, this.props.errorUnderAge) : null, this.state.errorInvalid ? _react2.default.createElement('span', {
        className: 'error error--invalid'
      }, this.props.errorInvalid) : null, _react2.default.createElement('form', {
        className: 'agegate__form',
        onSubmit: this.handleSubmit
      }, _react2.default.createElement('div', {
        className: 'date date--year'
      }, _react2.default.createElement('label', {
        className: 'date__label date__label--year',
        htmlFor: 'year'
      }, this.props.year, _react2.default.createElement('input', {
        className: 'date__input date__input--year',
        id: 'year',
        type: 'text',
        name: 'year',
        value: this.state.yearValue,
        title: this.props.yearTitle,
        onChange: this.handleYearChange,
        pattern: '\\d*',
        placeholder: 'YYYY',
        required: true,
        maxLength: '4',
        min: '1900',
        max: '2100'
      }))), this.state.isTwentyOne ? _react2.default.createElement('span', null, _react2.default.createElement('div', {
        className: 'date date--month'
      }, _react2.default.createElement('label', {
        className: 'date__label date__label--month',
        htmlFor: 'month'
      }, this.props.month, _react2.default.createElement('input', {
        className: 'date__input date__input--month',
        id: 'month',
        type: 'text',
        value: this.state.monthValue,
        title: this.props.monthTitle,
        onChange: this.handleMonthChange,
        pattern: '\\d*',
        maxLength: '2',
        placeholder: 'MM',
        max: '12'
      }))), _react2.default.createElement('div', {
        className: 'date date--day'
      }, _react2.default.createElement('label', {
        className: 'date__label date__label--day',
        htmlFor: 'day'
      }, this.props.day, _react2.default.createElement('input', {
        className: 'date__input date__input--day',
        id: 'day',
        type: 'text',
        value: this.state.dayValue,
        title: this.props.dayTitle,
        onChange: this.handleDayChange,
        pattern: '\\d*',
        maxLength: '2',
        placeholder: 'DD',
        max: '31'
      })))) : null, this.props.copy_2 ? _react2.default.createElement('h2', {
        className: 'agegate__copy'
      }, this.props.copy_2) : null, _react2.default.createElement('input', {
        className: 'agegate__submit',
        id: 'submit',
        type: 'submit',
        name: 'submit',
        value: this.props.enter
      }), _react2.default.createElement('span', {
        className: 'agegate__legal'
      }, this.props.legal)))) : null);
    }
  }]);
  return Agegate;
}(_react2.default.Component);
Agegate.defaultProps = {
  bgMobile: '',
  bgDesktop: '',
  className: '',
  copy: 'What year were you born?',
  copy_2: null,
  headlineImage: null,
  headlineImageAlt: '',
  headline: '',
  leaveTimeout: 350,
  legal: 'You must be 21 or older to enjoy. Please drink responsibly.',
  year: 'Year',
  month: 'Month',
  day: 'Day',
  enter: '|  Enter Recipes  |',
  yearTitle: 'Please enter a year in YYYY format',
  monthTitle: 'Please enter a month in MM format',
  dayTitle: 'Please enter a day in DD format',
  errorUnderAge: 'Sorry, it doesn\'t look like you\'re old enough.',
  errorInvalid: 'There was an error submitting your form. Make sure that you have entered a valid date.',
  onCookieCheck: function onCookieCheck($this) {
    var agegateCookieValue = Cookies.get('over21');
    if (!Number(agegateCookieValue)) {
      $this.setState({
        isShown: true
      });
    }
  },
  onYearChange: function onYearChange(e, $this) {
    var currentDate = new Date();
    var currentYear = currentDate.getFullYear();
    var year = e.target.value;
    $this.setState({
      yearValue: year
    });
    if (year >= 1900 && currentYear - year === 21) {
      $this.setState({
        isTwentyOne: true
      });
    } else if ($this.state.isTwentyOne) {
      $this.setState({
        isTwentyOne: false
      });
      $this.setState({
        monthValue: ''
      });
      $this.setState({
        dayValue: ''
      });
    }
  },
  onMonthChange: function onMonthChange(e, $this) {
    $this.setState({
      monthValue: e.target.value
    });
  },
  onDayChange: function onDayChange(e, $this) {
    $this.setState({
      dayValue: e.target.value
    });
  },
  onSubmit: function onSubmit(e, $this) {
    e.preventDefault();
    if ($this.state.errorUnderAge) $this.setState({
      errorUnderAge: false
    });
    if ($this.state.errorInvalid) $this.setState({
      errorInvalid: false
    });
    var currentDate = new Date();
    var currentYear = currentDate.getFullYear();
    var year = $this.state.yearValue;
    var month = $this.state.monthValue;
    var day = $this.state.dayValue;
    var validDate = year >= 1900 && year < currentYear;
    if (currentYear - year === 21) {
      validDate = month >= 1 && month <= 12 && day >= 1 && day <= 31;
    }

    /*
    * If month and day weren't entered, set birthDate to January 1
    * of the next year to prevent getting through with just the year 21
    */
    var birthDate = Number.isNaN(month) || Number.isNaN(day) ? new Date(year + 1, 0, 1) : new Date(year, month - 1, day);
    var age = currentDate.getFullYear() - birthDate.getFullYear();
    var m = currentDate.getMonth() - birthDate.getMonth();
    if (m < 0 || m === 0 && currentDate.getDate() < birthDate.getDate()) {
      age -= 1;
    }
    if (!validDate) {
      $this.setState({
        errorInvalid: true
      });
    } else if (validDate && age < 21) {
      $this.setState({
        errorUnderAge: true
      });
    } else {
      $this.setState({
        isShown: false
      });
      Cookies.set('over21', '1', {
        expires: 1
      });
    }
  }
};
Agegate.propTypes = {
  bgMobile: _propTypes2.default.string,
  bgDesktop: _propTypes2.default.string,
  className: _propTypes2.default.string,
  headline: _propTypes2.default.string,
  headlineImage: _propTypes2.default.string,
  headlineImageAlt: _propTypes2.default.string,
  leaveTimeout: _propTypes2.default.number,
  legal: _propTypes2.default.string,
  copy: _propTypes2.default.string,
  copy_2: _propTypes2.default.string,
  year: _propTypes2.default.string,
  month: _propTypes2.default.string,
  day: _propTypes2.default.string,
  enter: _propTypes2.default.string,
  yearTitle: _propTypes2.default.string,
  monthTitle: _propTypes2.default.string,
  dayTitle: _propTypes2.default.string,
  errorUnderAge: _propTypes2.default.string,
  errorInvalid: _propTypes2.default.string,
  onCookieCheck: _propTypes2.default.func,
  onYearChange: _propTypes2.default.func,
  onMonthChange: _propTypes2.default.func,
  onDayChange: _propTypes2.default.func,
  onSubmit: _propTypes2.default.func
};
exports.default = Agegate;